const AUTH_START = "AUTH_START";
const AUTH_SUCCESS = "AUTH_SUCCESS";
const AUTH_FAILURE = "AUTH_FAILURE";
const SET_MFA_REQUIRED = "SET_MFA_REQUIRED";

const initialState = {
  loading: false,
  error: null,
  token: null,
  mfaRequired: false,
};

const SigninPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, loading: true, error: null, mfaRequired: false };
    case AUTH_SUCCESS:
      return { ...state, loading: false, token: action.payload, error: null };
    case AUTH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_MFA_REQUIRED:
      return { ...state, loading: false, mfaRequired: true };
    default:
      return state;
  }
};

export default SigninPageReducer;
